<template>
  <div class="class='flex flex-col overflow-y-auto'" v-if="!isCompanyDoctor">
    <div v-for="(patient, index) in requests" :key="index" class="hover:bg-grey-extralight flex flex-col px-3 py-4 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest justify-center cursor-pointer">
        <div class="flex flex-row justify-between mb-1 h-4">
            <div class="text-sm font-semibold text-grey-darkest capitalize">{{patient.customer_name}}</div>
            <div v-if="patient.isFamilyDoctor && patient.status === 'queried' && patient.request_type === 'missed'"><img src="../../assets/missed.svg" alt="Personal Patient" style="width:20px; height:20px"></div>
            <div v-if="patient.isFamilyDoctor && patient.status === 'queried' && patient.request_type === 'queried'" class="py-1 px-2 self-center text-xs font-semibold justify-center items-center" style="border-radius: 25px; color:#70411b; background-color:#faedce" >Query</div>
            <div v-if="patient.isFamilyDoctor && patient.status === 'unicasted'"><img src="../../assets/personal_patient.svg" alt="Personal Patient" style="width:20px; height:20px"></div>
        </div>
        <div class="flex flex-row justify-between mb-2">
            <div class="text-sm font-light text-grey-dark truncate">{{patient.chiefComplaint}}</div>
        </div>
        <div class="flex flex-row text-xs mt-1 justify-between">
            <div class="text-xs font-light text-grey-dark">{{patient.time | formatDate}}</div>
            <div v-if="patient.isFamilyDoctor && patient.status === 'queried' && patient.request_type === 'queried'">
              <button @click="acceptQuery(patient)" class="text-blue font-semibold ml-auto">REPLY</button>
            </div>
            <div v-else-if="patient.isFamilyDoctor && patient.status === 'queried' && patient.request_type === 'missed'">
              <button @click="acceptQuery(patient)" class="text-blue font-semibold ml-auto">RESPOND BACK</button>
            </div>
            <div v-else>
              <button @click="accept(patient)" class="text-blue ml-auto font-semibold mr-2">ACCEPT</button>
            </div>  
        </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  data () {
    return {
      isCompanyDoctor: false,
      patientOnHold: true,
      isActive: true,
      isClosable: true
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  computed: {
    ...mapGetters({
      requests: 'consultationRequest/getRequests'
    })
  },
  methods: {
    accept: function (request) {
      this.$store.dispatch('consultationRequest/acceptConsultationRequest', request)
    },
    acceptQuery: function (request) {
      this.$store.dispatch('consultationRequest/acceptQueriedConsultationRequest', request)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Consultations/IncomingRequests.vue